const Restaurants = [
    {
        "name": "Armani/Mediterraneo",
        "description": "Hotel Buffet",
        "long_description": "A wonderful dining experience at Armani/Mediterraneo. The food was excellent!\n\nGreat variety on the menu with standout seafood that tasted incredibly fresh. The dessert section alone is worth the visit.\n\nA few tips for first-timers: visit during the cooler months for the best experience, and when booking, request a table outside. Just make sure to ask for one away from the smoking section.",
        "location": {
            "address": "1 Mohammed Bin Rashid Boulevard, Burj Khalifa, Armani Hotel Dubai, Downtown Dubai 888333, UAE",
            "area": "Downtown",
            "googleMapsURL": "https://maps.app.goo.gl/KQ7RKs5fP2W8dxrX8",
            "googleMapsPlusCode": "57WF+XM Dubai",
            "coordinates": {
                "lat": {
                    "$numberDouble": "25.1957"
                },
                "lng": {
                    "$numberDouble": "55.2741"
                }
            }
        },
        "cuisine": "International/Spanish",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 349",
        },
        "discountApps": [
            "The Entertainer"
        ],
        "rating": {
            "$numberDouble": "4.4"
        },
        "contactInfo": {
            "phone": "+97148883666",
            "email": "",
            "website": "https://www.armanihotels.com/en/restaurant/armani-mediterraneo/?hotel=armani-hotel-dubai"
        },
        "openingHours": {
            "monday": "6:30 PM - 10:00 PM",
            "tuesday": "6:30 PM - 10:00 PM",
            "wednesday": "6:30 PM - 10:00 PM",
            "thursday": "6:30 PM - 10:00 PM",
            "friday": "6:30 PM - 10:00 PM",
            "saturday": "6:30 PM - 10:00 PM",
            "sunday": "6:30 PM - 10:00 PM"
        },
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/06/ff/05/f3/mediterraneo.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Seafood",
            "Outdoor Seating",
            "Romantic",
            "Buffet",
            "Burj Khalifa"
        ],
        "dateIdeas": [
            {
                "title": "Sunset Dinner",
                "description": "Enjoy a romantic dinner while watching the sunset over the Arabian Gulf."
            },
            {
                "title": "Fountain Show",
                "description": "See the Burj Khalifa fountain show. "
            }
        ]
    },
    {
        "name": "Ginger Moon",
        "description": "Pool side brunch",
        "long_description": "A fantastic experience at Ginger Moon. The breakfast brunch is the real highlight here. A lovely spread enjoyed in one of the most relaxed settings around.\n\nWhat makes it special is being able to kick back by the pool afterward, making it the perfect way to spend a leisurely morning or afternoon.\n\nIf you're looking for great food combined with a chill poolside atmosphere, this is the place. Definitely book the brunch, you won't regret it.",
        "location": {
            "address": "W Dubai, Mina Seyahi, King Salman Bin Abdulaziz Al Saud Street, Dubai Marina, Dubai 213084, UAE",
            "area": "Dubai Marina",
            "googleMapsURL": "https://maps.app.goo.gl/6Zs8e9a5W3D4m2K1L",
            "googleMapsPlusCode": "34RW+JJ Dubai",
            "coordinates": {
                "lat": {
                    "$numberDouble": "25.0725"
                },
                "lng": {
                    "$numberDouble": "55.1373"
                }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$",
            "priceForTwo": "AED 295",
        },
        "discountApps": [
            "The Entertainer",
            "Careem"
        ],
        "rating": {
            "$numberDouble": "4.1"
        },
        "contactInfo": {
            "phone": "+97143509998",
            "email": "",
            "website": "https://www.destinationminaseyahi.com/dining/ginger-moon"
        },
        "openingHours": {
            "monday": "6:30 PM - 10:00 PM",
            "tuesday": "6:30 PM - 10:00 PM",
            "wednesday": "6:30 PM - 10:00 PM",
            "thursday": "6:30 PM - 10:00 PM",
            "friday": "6:30 PM - 10:00 PM",
            "saturday": "6:30 PM - 10:00 PM",
            "sunday": "6:30 PM - 10:00 PM"
        },
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2e/df/57/91/ginger-moon-indoor-seating.jpg?w=1400&h=-1&s=1"
        ],
        "features": [
            "Scenic View",
            "Outdoor Seating",
            "Pool",
            "Relaxed"
        ],
        "dateIdeas": [
            {
                "title": "Relaxing breakfast",
                "description": "Enjoy a relaxing poolside meal while looking at the Dubai skyline"
            }
        ]
    },
    {
        "name": "Reef & Beef",
        "description": "Steakhouse",
        "long_description": "A fantastic visit to Reef & Beef, an impressive steakhouse and seafood destination in Downtown Dubai. The quality of the meat here is genuinely exceptional, with perfectly aged steaks and impeccable preparation that makes it stand out.\n\nThe seafood selection is equally impressive, offering fresh catches cooked to perfection. The restaurant has a sophisticated yet welcoming atmosphere, making it ideal for both special occasions and upscale casual dining.\n\nWhat really sets Reef & Beef apart is the attention to detail in every dish. Pair your meal with their wine selection and don't skip the sides – they complement the proteins beautifully. If you're looking for a high-end steakhouse experience in Downtown Dubai with outstanding quality, this is absolutely worth the visit.",
        "location": {
            "address": "The Heritage Hotel, Autograph Collection, Sheikh Mohammed Bin Rashid Boulevard, Downtown Dubai, UAE",
            "area": "Downtown Dubai",
            "googleMapsURL": "https://maps.app.goo.gl/55ahVS5pXz4RcII_UjdpVKc",
            "googleMapsPlusCode": "57RH+J3 Dubai",
            "coordinates": {
                "lat": {
                    "$numberDouble": "25.1918"
                },
                "lng": {
                    "$numberDouble": "55.2748"
                }
            }
        },
        "cuisine": "Steakhouse/Seafood",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 419",
        },
        "discountApps": [
            "The Entertainer"
        ],
        "rating": {
            "$numberDouble": "4.8"
        },
        "contactInfo": {
            "phone": "+971522338473",
            "email": "",
            "website": "https://reefandbeef.ae/"
        },
        "openingHours": {
            "monday": "12:30 PM - 12:00 AM",
            "tuesday": "12:30 PM - 12:00 AM",
            "wednesday": "12:30 PM - 12:00 AM",
            "thursday": "12:30 PM - 12:00 AM",
            "friday": "12:30 PM - 12:00 AM",
            "saturday": "12:30 PM - 12:00 AM",
            "sunday": "12:30 PM - 12:00 AM"
        },
        "images": [
            "https://reefandbeef.ae/wp-content/uploads/2025/04/dining-image-2.png"
        ],
        "features": [
            "Impressive restaurant",
            "Great food"
        ],
        "dateIdeas": [
            {
                "title": "Impressing Steakdinner",
                "description": "Impress your date by taking her to an amazing steakdinner"
            }
        ]
    },
    {
        "name": "Mott 32",
        "description": "Chinese Brunch",
        "long_description": "A memorable experience at Mott 32, the Chinese brunch hotspot in Dubai Marina. Located on the 73rd floor with incredible marina views, this restaurant offers an authentic Asian dining experience elevated by stunning surroundings.\n\nThe brunch spread is fantastic, featuring traditional Chinese dishes alongside creative interpretations. The dim sum selection is particularly excellent, with fresh preparation and authentic flavors that remind you of Hong Kong's best.\n\nWhat makes this special is the combination of great food and those breathtaking views over Dubai Marina. Book well in advance for weekend brunch – it fills up quickly. If you want an upscale Chinese brunch experience with one of the best views in the city, Mott 32 absolutely delivers.",
        "location": {
            "address": "73rd Floor, Address Beach Resort, Jumeirah Beach Residence (JBR), Dubai Marina, Dubai",
            "area": "Dubai Marina",
            "googleMapsURL": "https://maps.app.goo.gl/mott32dubai",
            "googleMapsPlusCode": "34FG+2H Dubai",
            "coordinates": {
                "lat": {
                    "$numberDouble": "25.0726"
                },
                "lng": {
                    "$numberDouble": "55.1264"
                }
            }
        },
        "cuisine": "Chinese/Asian",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 375",
        },
        "discountApps": [
            "The Entertainer"
        ],
        "rating": {
            "$numberDouble": "4.6"
        },
        "contactInfo": {
            "phone": "+97142784832",
            "email": "",
            "website": "https://mott32.com/dubai"
        },
        "openingHours": {
            "monday": "12:30 PM - 16:00 PM",
            "tuesday": "12:30 PM - 16:00 PM",
            "wednesday": "12:30 PM - 16:00 PM",
            "thursday": "12:30 PM - 16:00 PM",
            "friday": "12:30 PM - 16:00 PM",
            "saturday": "12:30 PM - 16:00 PM",
            "sunday": "12:30 PM - 16:00 PM"
        },
        "images": [
            "https://mott32.com/fileadmin/_processed_/f/e/csm_MOT32_BeARTpro_015_03.01.23_b6a1ca44e1.jpg"
        ],
        "features": [
            "Impressive views",
            "Great food"
        ],
        "dateIdeas": [
            {
                "title": "Impressing with Asian food",
                "description": "Impress your date by taking her to an amazing steakdinner"
            }
        ]
    },
    {
        "name": "Carnival by Trèsind",
        "description": "Modern Indian Fine Dining",
        "long_description": "A truly spectacular dining experience at Carnival by Trèsind in DIFC. This isn't just dinner – it's a theatrical celebration of modern Indian cuisine. The moment you enter, you're captivated by the vibrant, colorful interiors and energetic atmosphere.\n\nEvery dish is a work of art with innovative presentations that make the meal feel like a performance. The flavors are bold and creative, pushing traditional Indian cuisine into exciting new territory while respecting the heritage. The service is attentive and knowledgeable, helping you navigate the unique menu.\n\nThis is perfect for a special occasion or when you want to impress with something truly different. The experience stays with you long after dinner. If you're ready to elevate your Indian dining experience, Carnival by Trèsind is an absolute must-visit.",
        "location": {
            "address": "Level P5, Burj Daman, 312 Al Sa'ada Street, Za'abeel, DIFC, Dubai, UAE",
            "area": "DIFC",
            "googleMapsURL": "https://maps.app.goo.gl/carnivaltresind",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1942" },
                "lng": { "$numberDouble": "55.2704" }
            }
        },
        "cuisine": "Indian",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 450"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.7" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": "https://www.carnivalbytresind.com"
        },
        "openingHours": {},
        "images": [
            "https://www.timeoutdubai.com/cloud/timeoutdubai/2021/09/15/azLnlAA6-2018_CarnivaL_by_Tresind_base.jpg",
            "https://carnivalbytresind.com/wp-content/uploads/2024/01/512x512-1.png"
        ],
        "features": [
            "Fine Dining",
            "Innovative Dishes",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Indian Tasting Menu",
                "description": "Experience a unique multi-course Indian tasting menu together."
            }
        ]
    },
    {
        "name": "Asador de Aranda",
        "description": "Spanish Steakhouse",
        "long_description": "An authentic taste of Spain at Asador de Aranda in Downtown Dubai. This traditional Spanish steakhouse specializes in roasted lamb and classic Castilian dishes that transport you straight to Spain.\n\nThe roasted lamb is the showstopper – it's tender, perfectly seasoned, and cooked exactly as it would be in Madrid. The menu features other Spanish specialties like grilled meats and traditional sides that complement the main proteins beautifully. The wine selection includes Spanish varieties that pair perfectly with the food.\n\nThe atmosphere is intimate and romantic, making it ideal for special dinners. The team really knows their craft and can guide you through authentic Spanish dining if you're unfamiliar with the cuisine. If you're craving genuine Spanish steakhouse experience with quality ingredients and traditional preparations, Asador de Aranda won't disappoint.",
        "location": {
            "address": "Sheikh Mohammed Bin Rashid Boulevard, The Address Downtown Hotel, Downtown Dubai, UAE",
            "area": "Downtown",
            "googleMapsURL": "https://maps.app.goo.gl/asadoraranda",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1921" },
                "lng": { "$numberDouble": "55.2745" }
            }
        },
        "cuisine": "Spanish",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 350"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.5" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://www.timeoutdubai.com/cloud/timeoutdubai/2021/10/01/zeo673V7-Asador-de-Aranda-1200x900.jpg",
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2d/7b/07/49/spanish-vibes.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Steakhouse",
            "Authentic Spanish",
            "Romantic"
        ],
        "dateIdeas": [
            {
                "title": "Spanish Feast",
                "description": "Share authentic Spanish dishes and roasted lamb."
            }
        ]
    },
    {
        "name": "Ming Dynasty Dubai",
        "description": "Chinese Fine Dining",
        "long_description": "A wonderful experience at Ming Dynasty Dubai, an elegant Chinese fine dining restaurant in Business Bay. The menu masterfully balances traditional Chinese classics with contemporary interpretations that feel fresh and exciting.\n\nThe dim sum here is excellent, with skilled chefs preparing each piece to order. Beyond dim sum, the restaurant excels at signature dishes that showcase high-quality ingredients and expert technique. The service is refined and helpful, guiding you through options without being intrusive.\n\nWhat makes Ming Dynasty special is how it respects Chinese culinary tradition while embracing modern innovation. The atmosphere is sophisticated and comfortable, perfect for business dinners or special occasions. If you want upscale Chinese dining with both heritage and creativity, this is definitely worth exploring.",
        "location": {
            "address": "3 Mohammed Bin Rashid Boulevard, Dubai Mall, Downtown Dubai, Dubai",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/mingdynastydubai",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1918" },
                "lng": { "$numberDouble": "55.2742" }
            }
        },
        "cuisine": "Chinese",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 300"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.4" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/30/ad/5e/52/welcome-to-the-ultimate.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Dim Sum",
            "Fine Dining",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Dim Sum Date",
                "description": "Enjoy sharing plates and authentic Chinese specialties."
            }
        ]
    },
    {
        "name": "The MAINE Land Brasserie",
        "description": "American Brasserie",
        "long_description": "An impressive dining experience at The MAINE Land Brasserie in Business Bay. This stylish steakhouse brings New England sophistication to Dubai with expertly prepared meats and fresh seafood.\n\nThe steaks here are dry-aged to perfection and cooked with precision – every cut delivers exceptional flavor and texture. The seafood is equally impressive, with daily specials featuring the freshest catches. The oyster bar is a great spot to start, and the wine selection complements both meat and fish beautifully.\n\nThe atmosphere is polished yet approachable, with a vibe that feels upscale without being stuffy. The team clearly cares about quality at every level. Whether you're celebrating a special occasion or enjoying a refined dinner night, The MAINE Land Brasserie offers a premium steakhouse experience that truly stands out.",
        "location": {
            "address": "Ground Floor, The Opus by Omniyat (ME by Meliá), Marasi Drive, Business Bay, Dubai, UAE",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/mainelandbrasserie",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1854" },
                "lng": { "$numberDouble": "55.2706" }
            }
        },
        "cuisine": "Steakhouse/Seafood",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 500"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": "https://themaine.ae"
        },
        "openingHours": {},
        "images": [
            "https://cdn.themainegroup.com/wp-content/uploads/2025/10/RE-EDIT-THE-MAINE-BATCH-1-HR-COLORED-BATCH-2-scaled.jpg"
        ],
        "features": [
            "Steakhouse",
            "Seafood",
            "Business Dinner"
        ],
        "dateIdeas": [
            {
                "title": "Luxury Dinner",
                "description": "Enjoy premium steaks and oysters with a sophisticated atmosphere."
            }
        ]
    },
    {
        "name": "Billionaire Dubai",
        "description": "Dinner Show Experience",
        "long_description": "An unforgettable evening at Billionaire Dubai, where luxury dining meets world-class entertainment. This isn't just a meal – it's a complete sensory experience that combines high-end cuisine with spectacular live performances.\n\nThe food showcases Italian and Japanese influences, expertly prepared and beautifully presented. But what really sets Billionaire Dubai apart is the energy and entertainment throughout the evening. Live performers, musicians, and dancers create an atmosphere that's glamorous and energetic without overshadowing the dining experience.\n\nThe service is attentive and polished, ensuring everything flows smoothly. This is the place to go when you want to celebrate in style and create a memorable night. Book well in advance – this venue is popular for good reason. If you're looking to impress and want a truly special evening with entertainment, great food, and luxury atmosphere, Billionaire Dubai delivers on all fronts.",
        "location": {
            "address": "Taj Dubai Hotel, Burj Khalifa Boulevard, Business Bay, Dubai, UAE",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/billionairedubai",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1921" },
                "lng": { "$numberDouble": "55.2674" }
            }
        },
        "cuisine": "Italian/Japanese",
        "price": {
            "priceRange": "$$$$$",
            "priceForTwo": "AED 1200"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": "https://billionairedubai.com"
        },
        "openingHours": {},
        "images": [
            "https://billionairesociety.com/dubai/hideout-app/app-uploads/sites/15/2025/11/billionaire-dubai-photo-29.webp"
        ],
        "features": [
            "Luxury",
            "Live Entertainment",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Dinner & Show",
                "description": "Enjoy a glamorous evening of dining and entertainment."
            }
        ]
    },
    {
        "name": "Al Dawaar Revolving Restaurant",
        "description": "Revolving Buffet Restaurant",
        "long_description": "A classic Dubai experience at Al Dawaar, the iconic revolving restaurant on the 25th floor of the Hyatt Regency in Deira. The main attraction here is undoubtedly the slowly rotating dining room that gives you panoramic city views from every table.\n\nThe buffet offers a solid variety of international and Arabian dishes, with live cooking stations keeping things fresh. While you eat, the entire city rotates around you – it's a visual experience that makes this special regardless of what's on your plate. The sunsets from here are particularly stunning.\n\nThis is a fun, nostalgic Dubai experience that feels timeless. It's great for families, dates, or just a memorable evening out. Come for the views and atmosphere, and you'll enjoy a pleasant dinner. If you want to experience a piece of Dubai's dining history with loved ones and incredible skyline views, Al Dawaar is worth adding to your list.",
        "location": {
            "address": "25th Floor, Hyatt Regency Dubai, Al Khaleej Road, Deira, Dubai, UAE",
            "area": "Deira",
            "googleMapsURL": "https://maps.app.goo.gl/aldawaar",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.2645" },
                "lng": { "$numberDouble": "55.3165" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 350"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.5" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/11/06/e1/14/al-dawaar-revolving-restaurant.jpg?w=1800&h=1000&s=1",
            "https://res.cloudinary.com/wejgrnjqf/image/upload/c_limit,w_2560/f_auto/q_auto/v1/7aa28757-4ace-464c-a9cc-8a0763c8c9d6"
        ],
        "features": [
            "Buffet",
            "360 Views",
            "Romantic"
        ],
        "dateIdeas": [
            {
                "title": "Skyline Dinner",
                "description": "Watch Dubai's skyline rotate around you while dining."
            }
        ]
    },
    {
        "name": "Flow Kitchen",
        "description": "International Buffet",
        "long_description": "A fantastic family-friendly experience at Flow Kitchen, located at Fairmont The Palm on beautiful Palm Jumeirah. This popular buffet restaurant rotates through themed international cuisines, keeping things fresh and exciting each visit.\n\nThe buffet variety is impressive, with stations covering different regions and cooking styles. The quality is solid across the board, and you can definitely find something for every palate. The real draw here is the beautiful beach location – you get sea views and access to the property's facilities, making it perfect for a leisurely day.\n\nThe atmosphere is relaxed and fun, ideal for families or casual group dining. You can enjoy your meal and then relax by the pool or beach afterward. If you want buffet dining combined with a great beach resort setting on the Palm, Flow Kitchen is a reliable choice that delivers good food with an excellent location.",
        "location": {
            "address": "Beach Level, Fairmont The Palm, Palm Jumeirah, Dubai 72413, UAE",
            "area": "Palm Jumeirah",
            "googleMapsURL": "https://maps.app.goo.gl/flowkitchen",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1386" },
                "lng": { "$numberDouble": "55.1493" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$",
            "priceForTwo": "AED 250"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.5" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://m.ahstatic.com/is/image/accorhotels/met_p_a144-45:8by10?fmt=jpg&op_usm=1.75,0.3,2,0&resMode=sharp2&iccEmbed=true&icc=sRGB&dpr=on,1.5&wid=335&hei=418&qlt=80"
        ],
        "features": [
            "Buffet",
            "Family Friendly",
            "Palm Jumeirah"
        ],
        "dateIdeas": [
            {
                "title": "Casual Brunch",
                "description": "Relaxed buffet brunch with plenty of options."
            }
        ]
    },
    {
        "name": "Spice Island",
        "description": "International Buffet",
        "long_description": "An incredible buffet experience at Spice Island in Deira, one of Dubai's most legendary dining destinations. With over 200 dishes and multiple live cooking stations, this place is a food lover's paradise.\n\nThe variety is staggering – you'll find cuisines from around the world, each prepared with genuine care and attention. The live stations let you customize dishes to your taste, and watching the chefs work is part of the fun. The quality is consistently impressive across such a massive selection, which isn't easy to achieve.\n\nThe atmosphere is bustling and energetic, especially during peak times. Come hungry and come with an adventurous spirit – there's so much to explore. This is perfect for families, groups, or anyone who wants to take a culinary world tour in one evening. If you want the best buffet experience Dubai has to offer with incredible variety and quality, Spice Island absolutely lives up to its legendary reputation.",
        "location": {
            "address": "Lobby Level, Crowne Plaza Dubai Deira, Salahuddin Road, Al Muteena, Dubai, UAE",
            "area": "Deira",
            "googleMapsURL": "https://maps.app.goo.gl/spiceisland",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.2688" },
                "lng": { "$numberDouble": "55.3268" }
            }
        },
        "cuisine": "International/Asian",
        "price": {
            "priceRange": "$$",
            "priceForTwo": "AED 220"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.7" },
        "contactInfo": {
            "phone": "+97146088085",
            "email": "",
            "website": ""
        },
        "openingHours": {
            "daily": "12:30 PM - 3:30 PM, 7:00 PM - 11:00 PM"
        },
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1b/00/5a/30/chef-cooking-on-mongolian.jpg"
        ],
        "features": [
            "Buffet",
            "Live Cooking Stations",
            "Family Friendly"
        ],
        "dateIdeas": [
            {
                "title": "World Food Tour",
                "description": "Travel across cuisines together in one evening."
            }
        ]
    },
    {
        "name": "Prime68",
        "description": "Luxury Steakhouse",
        "long_description": "A spectacular dining experience at Prime68, the luxury steakhouse on the 68th floor of the JW Marriott Marquis. This place combines world-class steaks with some of the most breathtaking panoramic views in Dubai.\n\nThe steaks are exceptional – perfectly aged, expertly cooked, and served with refined sides and accompaniments. The menu features premium cuts sourced from around the world, and the preparation shows genuine expertise. The wine selection is carefully curated to pair beautifully with the meat.\n\nWhat really sets Prime68 apart is the full experience. The service is impeccable, the views are jaw-dropping, and every detail is polished. This is the place for truly special occasions or when you want to really impress. Book a table with skyline views and arrive for sunset if you can. If you're looking for an unforgettable high-end steakhouse experience with stunning views, Prime68 is absolutely worth the splurge.",
        "location": {
            "address": "68th Floor, JW Marriott Marquis Hotel Dubai, Sheikh Zayed Road, Business Bay, Dubai 121000, UAE",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/prime68",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1846" },
                "lng": { "$numberDouble": "55.2622" }
            }
        },
        "cuisine": "Steakhouse",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 650"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.5" },
        "contactInfo": {
            "phone": "+97144143000",
            "email": "jwmmrr@marriott.com",
            "website": "https://www.prime68dubai.com"
        },
        "openingHours": {
            "daily": "5:30 PM - 12:00 AM"
        },
        "images": [
            "https://mds-assets.marriott.com/cdn-cgi/image/f=auto/cms-platform-for-marriott/dxbjw-prime68/site-images/migrated-images/prime68-dubai-steakhouse-view-from-the-68th-floor.jpg?width=900&height=404",
            "https://www.prime68dubai.com/wp-content/uploads/2023/09/prime68.jpg"
        ],
        "features": [
            "Skyline Views",
            "Luxury Dining",
            "Steakhouse"
        ],
        "dateIdeas": [
            {
                "title": "Sky High Steak Date",
                "description": "Enjoy premium steaks overlooking the Dubai skyline."
            }
        ]
    },
    {
        "name": "Frevo",
        "description": "Brazilian Churrascaria",
        "long_description": "An authentic Brazilian celebration at Frevo, the churrascaria located at Fairmont The Palm. This is a meat lover's dream – endless skewers of perfectly grilled meats served tableside with traditional Brazilian hospitality.\n\nThe meat selection is outstanding, with different cuts cooked to perfection and brought to your table continuously. There's also a salad bar with fresh sides and traditional accompaniments that round out the experience. The energy and atmosphere are joyful and vibrant, reflecting the spirit of Brazilian dining.\n\nThis is the kind of place where you come hungry and ready to have fun. The service team moves seamlessly around the dining room, ensuring no one goes without their next favorite cut. If you want an interactive, festive dinner experience with premium grilled meats and that special Brazilian energy, Frevo delivers an unforgettable churrascaria experience.",
        "location": {
            "address": "Lobby Level, Fairmont The Palm, 12 Palm Jumeirah Road, Palm Jumeirah, Dubai, UAE",
            "area": "Palm Jumeirah",
            "googleMapsURL": "https://maps.app.goo.gl/frevo",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1386" },
                "lng": { "$numberDouble": "55.1493" }
            }
        },
        "cuisine": "Brazilian",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 420"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://m.ahstatic.com/is/image/accorhotels/met_p_a135-81:8by10?fmt=jpg&op_usm=1.75,0.3,2,0&resMode=sharp2&iccEmbed=true&icc=sRGB&dpr=on,1.5&wid=335&hei=418&qlt=80"
        ],
        "features": [
            "Unlimited Meat",
            "Live Grill",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Brazilian Feast",
                "description": "Share a fun churrascaria dining experience."
            }
        ]
    },
    {
        "name": "The Cavendish",
        "description": "International Restaurant",
        "long_description": "A wonderful casual dining experience at The Cavendish, located in the Bonnington Hotel in Jumeirah Lakes Towers. This elegant yet approachable restaurant is known for its rotating themed nights and generous buffet spread.\n\nThe buffet offers good variety with international dishes that change with the theme of the night. The preparation is solid, and there's always something for different tastes and preferences. The themed nights add variety and keep regular diners coming back to try something new.\n\nThe atmosphere is relaxed and friendly, making it perfect for casual dinners or groups. The value is excellent for the quality offered. Come expecting a fun, laid-back evening with decent food and friendly service. If you're looking for casual, good-value buffet dining with themed variety in JLT, The Cavendish is a reliable choice.",
        "location": {
            "address": "Cluster J, Bonnington Hotel & Residence, Jumeirah Lakes Towers (JLT), Dubai 37246, UAE",
            "area": "JLT",
            "googleMapsURL": "https://maps.app.goo.gl/cavendish",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1412" },
                "lng": { "$numberDouble": "55.2066" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$",
            "priceForTwo": "AED 250"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.4" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/07/a2/22/f9/cavendish-terrace.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Buffet",
            "Casual Dining",
            "Brunch"
        ],
        "dateIdeas": [
            {
                "title": "Casual Dinner",
                "description": "Relaxed atmosphere perfect for getting to know each other."
            }
        ]
    },
    {
        "name": "Yalumba",
        "description": "Award Winning Brunch",
        "long_description": "An iconic Dubai experience at Yalumba, one of the most legendary brunch destinations in the city. Located at Le Méridien Dubai, this place has earned its reputation with years of delivering exceptional brunches that keep people coming back.\n\nThe spread is generous and diverse, with international cuisine that covers everything from seafood to carved meats to Arabian specialties. The live cooking stations let you customize your experience, and the quality stays high throughout the meal. The brunch comes with unlimited beverages, making it a complete experience.\n\nThe atmosphere is festive and fun, especially popular on weekends when it buzzes with energy. This is where many Dubai brunch traditions were created. Book early, come hungry, and plan to spend a good few hours here. If you want to experience a true Dubai institution and one of the best-known brunches in the city, Yalumba is absolutely essential.",
        "location": {
            "address": "Lobby Level, Le Méridien Dubai Hotel & Conference Centre, Airport Road, Al Garhoud, Dubai, UAE",
            "area": "Garhoud",
            "googleMapsURL": "https://maps.app.goo.gl/yalumba",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.2448" },
                "lng": { "$numberDouble": "55.3207" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 350"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/5c/33/11/yalumba-interior.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Famous Brunch",
            "Buffet",
            "Live Stations"
        ],
        "dateIdeas": [
            {
                "title": "Weekend Brunch",
                "description": "Experience one of Dubai's most popular brunches together."
            }
        ]
    },
    {
        "name": "Ewaan",
        "description": "Arabian Dining",
        "long_description": "A magnificent dining experience at Ewaan, the elegant Arabian restaurant at Palace Downtown with unforgettable views of Burj Khalifa and Dubai Fountain. This is where traditional Middle Eastern cuisine meets sophisticated hospitality and breathtaking scenery.\n\nThe menu celebrates Arabian flavors with refined preparations that feel both authentic and contemporary. Everything from mezze to grilled meats is executed with care. The signature dishes showcase the best of Middle Eastern culinary traditions, with exceptional attention to quality ingredients and technique.\n\nThe highlight is undoubtedly the location – watching the Fountain shows from your table while dining creates a magical atmosphere. Request a table outside if weather permits. This is the place for romantic occasions or when you want to celebrate while enjoying Burj Khalifa views. If you want an upscale Arabian dining experience combined with iconic Dubai views, Ewaan is unbeatable.",
        "location": {
            "address": "Ground Level, Palace Downtown, Sheikh Mohammed Bin Rashid Boulevard, Downtown Dubai, UAE",
            "area": "Downtown Dubai",
            "googleMapsURL": "https://maps.app.goo.gl/ewaan",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1913" },
                "lng": { "$numberDouble": "55.2749" }
            }
        },
        "cuisine": "Middle Eastern",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 400"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0a/78/48/f1/ewaan.jpg"
        ],
        "features": [
            "Burj Khalifa View",
            "Arabic Cuisine",
            "Romantic"
        ],
        "dateIdeas": [
            {
                "title": "Fountain View Dinner",
                "description": "Enjoy Arabic cuisine overlooking Dubai Fountain."
            }
        ]
    },
    {
        "name": "Kitchen6",
        "description": "International Buffet",
        "long_description": "An interactive and engaging dining experience at Kitchen6, located at JW Marriott Marquis in Business Bay. The name says it all – six live cooking stations where you watch chefs prepare dishes right in front of you, then customize them to your exact preferences.\n\nThe interactive element makes dining here genuinely fun and entertaining. You can request specific preparations, ask for recommendations, and watch the skill unfold. The international variety across the stations means there's something for every craving, from Asian to European styles. The quality is consistently solid across all stations.\n\nThe atmosphere is lively and social, perfect for families or groups who enjoy a more hands-on dining experience. There's always something happening at the stations to keep things dynamic. If you want buffet dining that feels interactive and engaging with the chefs involved in your meal, Kitchen6 is a fantastic choice.",
        "location": {
            "address": "Level 1, JW Marriott Marquis Hotel Dubai, Sheikh Zayed Road, Business Bay, Dubai 121000, UAE",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/kitchen6",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1846" },
                "lng": { "$numberDouble": "55.2622" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 280"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.5" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/03/a3/74/ef/main-dining-area.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Buffet",
            "Live Cooking",
            "Large Selection"
        ],
        "dateIdeas": [
            {
                "title": "Food Adventure",
                "description": "Try dishes from multiple cuisines in one evening."
            }
        ]
    },
    {
        "name": "The Restaurant - Address Creek Harbour",
        "description": "Luxury All-Day Dining",
        "long_description": "An upscale and refined dining experience at The Restaurant in Address Grand Creek Harbour, a stunning newer dining destination. The main attraction here is the beautiful views over Dubai Creek Harbour – watching the waterfront come alive while you dine is genuinely special.\n\nThe menu offers international cuisine with quality ingredients and refined preparations suitable for lunch, dinner, or special occasions. The service is polished and attentive, ensuring a smooth experience throughout your meal. The location is still relatively new, giving it a fresh, modern atmosphere that feels contemporary and welcoming.\n\nThis is becoming a popular spot for those seeking beautiful views without the crowd of more established locations. The creek views are particularly lovely at sunset. If you want upscale dining in a scenic location that feels fresh and modern, The Restaurant at Address Creek Harbour is well worth discovering.",
        "location": {
            "address": "Lobby Level, Address Grand Creek Harbour, Ras Al Khor, Dubai Creek Harbour, Dubai 92137, UAE",
            "area": "Dubai Creek Harbour",
            "googleMapsURL": "https://maps.app.goo.gl/addresscreekrestaurant",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1937" },
                "lng": { "$numberDouble": "55.3452" }
            }
        },
        "cuisine": "International",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 320"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": "https://www.addresshotels.com"
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/27/ad/ae/af/the-restaurant-dining.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Creek Views",
            "Luxury Hotel",
            "Scenic"
        ],
        "dateIdeas": [
            {
                "title": "Sunset Creek Dinner",
                "description": "Watch the sunset over Dubai Creek Harbour."
            }
        ]
    },
    {
        "name": "Seafire Steakhouse & Bar",
        "description": "Luxury Steakhouse",
        "long_description": "An exceptional luxury steakhouse experience at Seafire inside Atlantis The Palm. This New York-style establishment brings world-class steakhouse traditions to Dubai with impeccable execution and prime ingredients.\n\nThe steaks here are truly outstanding – dry-aged to perfection, cooked with precision, and served with sophisticated accompaniments. The seafood selection is equally impressive, with fresh preparations that showcase quality ingredients. The wine cellar is extensive and well-curated, with knowledgeable staff ready to help you find the perfect pairing.\n\nThe setting is luxurious and refined, befitting Atlantis The Palm. The service team understands fine dining and moves seamlessly to anticipate your needs. This is the place for celebrating special occasions or hosting important dinners. Book in advance and plan to dress up. If you want premium steakhouse dining at its finest with luxury resort surroundings, Seafire absolutely delivers.",
        "location": {
            "address": "Atlantis, The Palm, The Palm Jumeirah, Dubai, UAE",
            "area": "Palm Jumeirah",
            "googleMapsURL": "https://maps.app.goo.gl/seafire",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1319" },
                "lng": { "$numberDouble": "55.1188" }
            }
        },
        "cuisine": "Steakhouse",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 700"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.7" },
        "contactInfo": {
            "phone": "+97144261000",
            "email": "",
            "website": "https://www.atlantis.com/dubai/dining/seafire-steakhouse"
        },
        "openingHours": {},
        "images": [
            "https://assets.kerzner.com/api/public/content/7a034ce0604e483b872036d411842882?v=28589867&t=w620",
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/31/02/3e/5e/steak-on-grill.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Luxury Dining",
            "Premium Steak",
            "Atlantis"
        ],
        "dateIdeas": [
            {
                "title": "Luxury Steak Night",
                "description": "Enjoy premium cuts and wine pairings."
            }
        ]
    },
    {
        "name": "The Hide",
        "description": "Modern Steakhouse",
        "long_description": "A contemporary steakhouse experience at The Hide, located at Madinat Jumeirah with premium meat cuts and stylish, sophisticated interiors. This modern grill house respects classic steakhouse traditions while bringing fresh energy to the concept.\n\nThe meat selection is exceptional, with cuts sourced from premium suppliers and aged to develop maximum flavor. The cooking technique is precise – every steak arrives at your table exactly as you ordered it. Beyond steaks, the menu offers quality seafood and sides that complement the proteins beautifully.\n\nThe interior design is striking without being pretentious, creating an atmosphere that feels both luxurious and comfortable. The service is knowledgeable and attentive. This is perfect for special occasions or when you want an elevated steakhouse experience. If you want modern steakhouse dining with premium quality and stylish surroundings in a beautiful resort setting, The Hide is an excellent choice.",
        "location": {
            "address": "Jumeirah Al Qasr, Madinat Jumeirah, King Salman Bin Abdulaziz Al Saud Street, Dubai, UAE",
            "area": "Madinat Jumeirah",
            "googleMapsURL": "https://maps.app.goo.gl/thehide",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1317" },
                "lng": { "$numberDouble": "55.1847" }
            }
        },
        "cuisine": "Steakhouse",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 600"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.7" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://cdn.jumeirah.com/api/public/content/3481e61dbd8240a398cf7aa163cb59f8"
        ],
        "features": [
            "Premium Steak",
            "Luxury Dining",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Elegant Steak Dinner",
                "description": "Sophisticated steakhouse date experience."
            }
        ]
    },
    {
        "name": "World Cut Steakhouse",
        "description": "Premium Steakhouse",
        "long_description": "A refined steakhouse experience at World Cut, located in Al Habtoor City on Sheikh Zayed Road. This premium steakhouse specializes in beef sourced from around the world, offering a unique opportunity to taste and compare different styles and regions.\n\nThe meat quality is exceptional, with cuts that range from classic American ribeyes to premium wagyu and international selections. Each preparation honors the meat's unique characteristics, letting the quality shine through. The sommelier selection is thoughtfully curated to pair with each cut.\n\nThe atmosphere is sophisticated and business-friendly, making it ideal for important dinners or celebrations. The team clearly understands premium beef and can guide you through selections if you want recommendations. If you want to explore different beef traditions from around the world in a refined steakhouse setting, World Cut offers a truly educational and delicious experience.",
        "location": {
            "address": "Level 1, Al Habtoor City, Sheikh Zayed Road, Business Bay, Dubai, UAE",
            "area": "Business Bay",
            "googleMapsURL": "https://maps.app.goo.gl/worldcut",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.1825" },
                "lng": { "$numberDouble": "55.2640" }
            }
        },
        "cuisine": "Steakhouse",
        "price": {
            "priceRange": "$$$$",
            "priceForTwo": "AED 650"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.6" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://al-habtoor-palace.fra1.cdn.digitaloceanspaces.com/images/default/dxbpl_restaurant_world_cut_steakhouse-008_1716523662069.avif"
        ],
        "features": [
            "Premium Beef",
            "Luxury",
            "Business Dinner"
        ],
        "dateIdeas": [
            {
                "title": "Steak Tasting",
                "description": "Compare premium cuts sourced from around the world."
            }
        ]
    },
    {
        "name": "Bussola",
        "description": "Italian Restaurant",
        "long_description": "A wonderful Italian experience at Bussola, an award-winning restaurant at The Westin Dubai Mina Seyahi with beautiful beachfront location and marina views. This is where authentic Italian cuisine meets a relaxed seaside atmosphere.\n\nThe menu celebrates traditional Italian cooking with quality ingredients and genuine technique. The pasta dishes are handmade and prepared to order, with sauces that taste like they were made with care. The seafood, in particular, benefits from the coastal location – fresh preparations that let the fish shine. The wine list features Italian selections that pair beautifully with the food.\n\nWhat makes Bussola special is the combination of excellent food and that perfect beach setting – you can taste the Mediterranean influence in both the cuisine and the atmosphere. The sunset views are particularly lovely. This is ideal for romantic dinners or casual seaside meals with friends. If you want authentic Italian dining in a beautiful beachfront setting, Bussola is an absolutely delightful choice.",
        "location": {
            "address": "The Westin Dubai Mina Seyahi Beach Resort & Marina, King Salman Bin Abdulaziz Al Saud Street, Dubai Marina, Dubai 213084, UAE",
            "area": "Dubai Marina",
            "googleMapsURL": "https://maps.app.goo.gl/bussola",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.0755" },
                "lng": { "$numberDouble": "55.1398" }
            }
        },
        "cuisine": "Italian",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 350"
        },
        "discountApps": ["The Entertainer"],
        "rating": { "$numberDouble": "4.7" },
        "contactInfo": {
            "phone": "",
            "email": "",
            "website": ""
        },
        "openingHours": {},
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/11/f9/f6/2a/bussola-lounge.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "Beachfront",
            "Italian",
            "Romantic"
        ],
        "dateIdeas": [
            {
                "title": "Italian by the Sea",
                "description": "Enjoy handmade pasta with marina views."
            }
        ]
    },
    {
        "name": "Observatory Lounge",
        "description": "Rooftop Lounge & Restaurant",
        "long_description": "An absolutely spectacular experience at Observatory Lounge, the panoramic rooftop dining destination on the 52nd floor of Dubai Marriott Harbour Hotel in Dubai Marina. The views over Palm Jumeirah and the marina are genuinely breathtaking, especially at sunset.\n\nThe menu showcases creative Asian-Latin fusion cuisine that surprises and delights with unexpected flavor combinations. The cocktails are expertly crafted, with skilled bartenders who can create signature drinks or your favorite classics. The food matches the quality of the drinks – each plate is thoughtfully prepared with quality ingredients.\n\nThe atmosphere is vibrant and energetic, perfect for special occasions or nights when you want to celebrate. Book ahead, arrive for sunset if possible, and plan to spend the evening. The 360-degree views mean every table feels special. If you want rooftop dining with stunning views, creative cuisine, and world-class cocktails in an unforgettable setting, Observatory Lounge is absolutely unmissable.",
        "location": {
            "address": "52nd Floor, Dubai Marriott Harbour Hotel & Suites, King Salman Bin Abdulaziz Al Saud Street, Dubai Marina, Dubai, UAE",
            "area": "Dubai Marina",
            "googleMapsURL": "https://maps.app.goo.gl/observatory",
            "googleMapsPlusCode": "",
            "coordinates": {
                "lat": { "$numberDouble": "25.0806" },
                "lng": { "$numberDouble": "55.1396" }
            }
        },
        "cuisine": "Asian/Latin Fusion",
        "price": {
            "priceRange": "$$$",
            "priceForTwo": "AED 380"
        },
        "discountApps": [],
        "rating": { "$numberDouble": "4.8" },
        "contactInfo": {
            "phone": "+97143194795",
            "email": "welcome@observatorylounge.ae",
            "website": "https://www.observatorylounge.ae"
        },
        "openingHours": {
            "daily": "12:00 PM - 1:00 AM"
        },
        "images": [
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2e/51/a5/22/observatory-lounge-bar.jpg?w=900&h=500&s=1"
        ],
        "features": [
            "360 Views",
            "Rooftop",
            "Sunset Spot",
            "Date Night"
        ],
        "dateIdeas": [
            {
                "title": "Sunset Cocktails",
                "description": "Watch the sunset over Palm Jumeirah with cocktails and fusion cuisine."
            }
        ]
    }
]


export default Restaurants;